import catchAsync from "../../utils/catchAsync";
import httpsCall from "../httpsCall";

type ContactData = {
    firstname: string;
    lastname: string;
    email: string;
    phone: string;
    message: string;
};

export const ContactFormApi = catchAsync(async (values: ContactData) => {  
    const data = await httpsCall.post(`contact/contactus`, values);
    return data;
});